// extracted by mini-css-extract-plugin
export var divider = "_tg-0";
export var systemMessage = "_tg-1";